import { useMemo } from 'react'

import { type Brand } from '@redteclab/api/clients/bully'

import { useMarketplacePartnerRegisterPageFormApiSearchBrands } from '../api/swr/useMarketplacePartnerRegisterPageFormApiSearchBrands'

const MAX_BRANDS = 200

type UseMarketplacePartnerRegisterPageSearchBrandsParams = {
  max?: number
  query: string
}

interface UseMarketplacePartnerRegisterPageSearchBrandsReturn {
  isLoading: boolean
  searchBrands: Brand[] | undefined
}

export const useMarketplacePartnerRegisterPageSearchBrands = ({
  max = MAX_BRANDS,
  query,
}: UseMarketplacePartnerRegisterPageSearchBrandsParams): UseMarketplacePartnerRegisterPageSearchBrandsReturn => {
  const apiParams = useMemo(() => {
    return {
      max,
      // eslint-disable-next-line id-length -- api parameter
      q: query,
    }
  }, [query, max])

  const { data, isLoading } =
    useMarketplacePartnerRegisterPageFormApiSearchBrands(apiParams)

  return {
    isLoading,
    searchBrands: data,
  }
}
